(() => {
  const railSelector = '[data-cz-drapery-thumbnail-rail]';
  const itemSelector = '.cz-pdp-thumbnail-item';
  const buttonSelector = '.cz-pdp-thumbnail-button';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const coerceReducedMotion = element => {
    if (!element || element.dataset.czThumbnailMotionReady === 'true') return;
    element.dataset.czThumbnailMotionReady = 'true';
    ['scrollTo', 'scrollBy'].forEach(method => {
      const original = element[method].bind(element);
      element[method] = (...args) => {
        if (reduceMotion.matches && args.length === 1 && args[0] && typeof args[0] === 'object') {
          args[0] = { ...args[0], behavior: 'auto' };
        }
        return original(...args);
      };
    });
  };

  const enablePointerDrag = viewport => {
    if (!viewport || viewport.dataset.czThumbnailDragReady === 'true') return;
    viewport.dataset.czThumbnailDragReady = 'true';
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;

    viewport.addEventListener('mousedown', event => {
      if (event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
      event.stopImmediatePropagation();
    }, true);
    viewport.addEventListener('mousemove', event => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      if (!moved) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      viewport.scrollLeft = startScroll - delta;
    }, true);
    const stop = () => {
      if (!dragging) return;
      dragging = false;
    };
    viewport.addEventListener('mouseup', stop, true);
    viewport.addEventListener('mouseleave', stop, true);
    viewport.addEventListener('click', event => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
  };

  const mount = rail => {
    if (!rail || rail.dataset.czThumbnailRailReady === 'true') return;
    rail.dataset.czThumbnailRailReady = 'true';

    const items = () => [...rail.querySelectorAll(itemSelector)];
    const buttons = () => items().map(item => item.querySelector(buttonSelector)).filter(Boolean);
    const scroller = () => {
      const candidates = [
        rail.querySelector('.cz-pdp-thumbnail-scroller'),
        rail.querySelector('.cz-pdp-thumbnail-track'),
        rail.querySelector('.cz-pdp-thumbnail-list')
      ];
      return candidates.find(element => {
        if (!element || element.scrollWidth <= element.clientWidth + 1) return false;
        return ['auto', 'scroll'].includes(getComputedStyle(element).overflowX);
      }) || candidates.find(Boolean);
    };

    [
      rail.querySelector('.cz-pdp-thumbnail-scroller'),
      rail.querySelector('.cz-pdp-thumbnail-track'),
      rail.querySelector('.cz-pdp-thumbnail-list')
    ].forEach(coerceReducedMotion);

    const reveal = item => {
      const viewport = scroller();
      if (!viewport || !item) return;
      const left = item.offsetLeft;
      const right = left + item.offsetWidth;
      const viewLeft = viewport.scrollLeft;
      const viewRight = viewLeft + viewport.clientWidth;
      let next = viewLeft;
      if (left < viewLeft) next = left;
      else if (right > viewRight) next = right - viewport.clientWidth;
      if (next !== viewLeft) viewport.scrollTo({ left: next, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };

    enablePointerDrag(scroller());

    const sync = () => {
      let activeItem = rail.querySelector(`${itemSelector}.is-active`);
      if (!activeItem) activeItem = items()[0];
      items().forEach(item => {
        const button = item.querySelector(buttonSelector);
        if (!button) return;
        const active = item === activeItem;
        button.setAttribute('aria-pressed', String(active));
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      reveal(activeItem);
    };

    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const controls = buttons();
      const current = controls.indexOf(event.target.closest(buttonSelector));
      if (current < 0 || !controls.length) return;
      event.preventDefault();
      let target = current;
      if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = controls.length - 1;
      else if (event.key === 'ArrowRight') target = (current + 1) % controls.length;
      else target = (current - 1 + controls.length) % controls.length;
      controls[target].focus({ preventScroll: true });
      controls[target].click();
    });

    document.addEventListener('on:media-gallery:change', sync);
    new ResizeObserver(sync).observe(rail);
    requestAnimationFrame(sync);
  };

  const mountAll = root => {
    if (root.matches?.(railSelector)) mount(root);
    root.querySelectorAll?.(railSelector).forEach(mount);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(document), { once: true });
  else mountAll(document);
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
})();
